import { defineComponent, ref } from 'vue';
import { Row, Col } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ButtomCom from '@/components/buttomCom.vue';
import { JUMP_PAGE } from '@/uitl/currencyFunc';
export default defineComponent({
  components: {
    ARow: Row,
    ACol: Col,
    ButtomCom
  },
  setup() {
    let pageActive = ref(false);
    const jumpPage = (url, type) => {
      if (type == 2) {
        url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      }
      JUMP_PAGE(url);
    };
    return {
      jumpPage,
      pageActive
    };
  }
});